import { StyleSheet } from 'aphrodite';
import {
	brandPrimaryText,
	darkGrayFontColor,
	header,
	titles,
	brandPrimary,
	brandPrimaryHover,
	inputBorderColor,
	white,
	label,
	borderOutline,
} from '../../../styles/colors';
import { CssSelectors, cardStyle } from '../../../styles/styles';

const contentPaddingX = 20;

export const styleSheet = StyleSheet.create({
	automationCard: {
		...cardStyle,
		boxSizing: 'border-box',
		padding: '15px 20px',
		position: 'relative',
	},
	automationCardLabel: {
		margin: '12px 0 8px 0',
	},
	automationCardSelectButton: {
		color: brandPrimaryText,
	},
	automationCardSteps: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
	},
	automationCardSubTitle: {
		color: header,
		fontSize: 16,
		margin: '0 0 16px',
	},
	automationCardTitle: {
		color: brandPrimaryText,
		fontSize: 18,
		margin: 0,
	},
	sendToHoseholdCheckbox: {
		boxSizing: 'border-box',
		margin: '0 0 5px',
	},
	sendToHouseholdMessage: {
		color: darkGrayFontColor,
		margin: '0 0 30px 28px',
	},
	checkboxText: {
		color: label,
		fontSize: 14,
		marginBottom: 2,
		marginLeft: 16,
		marginTop: 0,
		width: 500,
	},
	narrowConfirmationDialog: {
		maxWidth: 450,
		width: '90vw',
	},
	body: {
		boxSizing: 'border-box',
		maxHeight: 495,
		overflowY: 'auto',
		padding: `25px ${contentPaddingX}px 26px ${contentPaddingX}px`,
		width: 500,
	},
	bodyOverflowVisible: {
		overflowY: 'visible',
	},
	buttonContainer: {
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: '0.5rem',
			},
			':not(:first-child)'
		),
	},
	contactOwners: {
		margin: 0,
	},
	container: {
		fontSize: 14,
	},
	ctaButton: {
		marginRight: 10,
	},
	formControl: {
		display: 'flex',
		margin: '0 0 20px',
	},
	formControlAdjusted: {
		margin: '0 0 10px',
	},
	header: {
		color: brandPrimaryText,
		fontSize: 24,
		margin: '0 0 8px',
	},
	modal: {
		...CssSelectors.allDescendants(
			{
				padding: 0,
			},
			'.modal-overlay-content'
		),
	},
	searchFieldWrap: {
		marginLeft: 10,
		width: 'calc(100% - 175px)',
	},
	selectedAutomation: {
		borderBottom: `1px solid ${inputBorderColor}`,
		marginBottom: 32,
		paddingBottom: 32,
	},
	title: {
		color: titles,
		fontSize: 18,
		marginBottom: 20,
		marginTop: 0,
	},
	filtersContainer: {
		marginBottom: 16,
		borderBottom: `1px solid ${borderOutline}`,
		paddingBottom: 16,
	},
	modalFilters: {
		// Custom filter layout for modal context
		display: 'flex',
		gap: 12,
		alignItems: 'center',
		flexWrap: 'nowrap',
		width: '100%',
	},
	modalSearchContainer: {
		// Make search box 50px shorter (250px instead of 300px)
		flex: '0 0 250px',
		width: 250,
	},
	modalCreatorFilterContainer: {
		// Ensure dropdown takes remaining space
		flex: '1 1 auto',
		minWidth: 150,
	},
	modalSearchInputWrapper: {
		background: white,
		borderRadius: 6,
		border: `1px solid ${inputBorderColor}`,
		height: 44,
		display: 'flex',
		alignItems: 'center',
		boxSizing: 'border-box',
		':hover': {
			borderColor: brandPrimary,
		},
	},
	modalSearchInput: {
		paddingLeft: 8,
	},
	modalSearchIcon: {
		width: 20,
		height: 20,
		marginRight: 8,
		flexShrink: 0,
	},
	modalClearButton: {
		background: 'none',
		border: 'none',
		color: brandPrimary,
		cursor: 'pointer',
		fontSize: 14,
		fontWeight: 500,
		padding: '4px 12px 4px 8px',
		borderRadius: 4,
		':hover': {
			fontWeight: 700,
		},
	},
	modalDropdownTrigger: {
		height: 44,
		width: '100%',
		borderRadius: 6,
		border: `1px solid ${inputBorderColor}`,
		backgroundColor: white,
		padding: 12,
		fontSize: 14,
		color: label,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		':hover': {
			borderColor: brandPrimary,
		},
	},
	modalDropdownContent: {
		maxHeight: 300,
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	modalDropdownItem: {
		padding: '8px 12px',
		fontSize: 14,
		color: label,
		cursor: 'pointer',
		':hover': {
			backgroundColor: brandPrimaryHover,
			color: white,
		},
	},
	emptyState: {
		textAlign: 'center',
		padding: '40px 20px',
		color: label,
		fontSize: 16,
		fontStyle: 'italic',
	},
});
